<div class="confirm-box-overlay" [ngClass]="{'active-overlay': confirm.text}"></div>
<div [ngClass]="{'active-alert': confirm.text}" class="confirm-wrapper alert-wrapper">

    <div class="confirm-content">
        <i class="fa fa-exclamation-triangle confirm-icon"></i>
        <p>{{confirm.text}}</p>
    </div>


    <div class="confirmdialogfooter">
        <a (click)="confirm.noFn()" class="float-right">
            <button id='confirm_No' class="secondary-button">No</button>
        </a>
        <a (click)="confirm.siFn()" class="float-right">
            <button id='confirm_Yes' class="primary-button">Yes</button>
        </a>
    </div>

</div>